module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_M4-8b3caa5a0801459a55eef2ad242235ab.webp";